import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MenuItem, MenuList } from "@mui/material";
import { updateUserAttributes } from "aws-amplify/auth";
import { useAuthContext } from "context";
import { Loading } from "core";
import { AdminIcon, OfficeIcon } from "modules/icons";
import useStyles from "./styles";

type HeaderUserRoleMenuProps = {
  handleMenuClose: () => void;
};

export const HeaderUserRoleMenu: React.FC<HeaderUserRoleMenuProps> = ({
  handleMenuClose,
}) => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const authContext = useAuthContext();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [roleToSelect, setRoleToSelect] = useState<string | null>(null);

  const user = authContext.cognitoUser;

  if (!user) {
    return null;
  }

  if (user.groups.length < 2) {
    return null;
  }

  const updateUserRole = async (newRole: string) => {
    setRoleToSelect(newRole);
    setIsLoading(true);
    await updateUserAttributes({
      userAttributes: {
        "custom:currentGroup": newRole,
      },
    });
    await authContext.reloadUserData();
    handleMenuClose();
    setRoleToSelect(null);
    setIsLoading(false);
    navigate("/");
  };

  const getUserRoleIcon = (value: string) => {
    switch (value) {
      case "Admin":
        return <AdminIcon />;
      case "employee":
        return <OfficeIcon />;
      default:
        throw new Error("Could not find userRole " + value);
    }
  };

  return (
    <MenuList className={classes.userRoleMenu}>
      {user.groups.map((group) => (
        <MenuItem
          key={group.groupID}
          onClick={() =>
            user.currentGroup.groupID !== group.groupID &&
            updateUserRole(group.groupID)
          }
          className={
            user.currentGroup.groupID === group.groupID
              ? classes.selectedRole
              : ""
          }
        >
          {isLoading && roleToSelect === group.groupID ? (
            <Loading size="21px" className={classes.loading} />
          ) : (
            getUserRoleIcon(group.groupID)
          )}
          {group.groupName}
        </MenuItem>
      ))}
    </MenuList>
  );
};
